<template>
  <div v-if="walletLabels">
    <ul class="flex flex-wrap">
      <li
        v-for="(item, index) in walletLabels"
        :key="index"
        v-tooltip="item.description"
        class="flex-none py-0.5 px-1 mr-1 mb-1 text-xs whitespace-nowrap bg-gray-400 rounded"
      >
        {{ item.displayName }}
      </li>
    </ul>
  </div>
</template>

<script>
import {
  defineComponent,
  computed,
  toRefs,
} from "vue";
import { useQuery } from "@vue/apollo-composable";
import walletLabelsQuery from "@/graphql/wallet/queries/walletLabels.query.gql";

export default defineComponent({
  props: ['wallet'],

  setup(props) {
    const {
      wallet,
    } = toRefs(props);

    const {
      result: walletLabelsResult,
    } = useQuery(walletLabelsQuery, () => ({ address: wallet.value?.id }));
    const walletLabels = computed(() => walletLabelsResult.value?.wallet.labels);

    return {
      walletLabels,
    };
  },
});
</script>

<style>

</style>